import React, { useEffect, useState } from "react";
import { useAuth } from "../../../firebase/AuthProvider";
import NewParticipant from "../../../interfaces/participant/NewParticipant";
import {
    GetParticipantByWaiverFamily,
    getWaivers,
    postParticipant,
} from "../../../services/participantServices/ParticipantService";
import { getAllRegions, getAllUsersInOrganizationbyId } from "../../../services/userServices/UserInfoService";
import UserInfo from "../../../interfaces/UserInfo";
import Waiver from "../../../interfaces/participant/Waiver";
import Select, { SingleValue } from "react-select";
import { useNavigate } from "react-router-dom";
import { Button, Form, Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import { DefaultUSCountryCodeId, ROLES } from "../../../Data/SD";
import backarrowbtn from '../../../assets/images/backarrowbtn.svg';
import { useSelectedRegion } from "../../../contexts/RegionContext";
import './partcipants.css';
import { UserWaiverDTO } from "../../../interfaces/Participant";
import { displayName } from "react-quill";
import { AxiosError } from "axios";


interface OptionType {
    value: string;
    label: string;
}

const CreateParticipantPage: React.FC = () => {
    const { currentUser, currentRoles } = useAuth();
    const navigate = useNavigate();
    const { availableRegions } = useSelectedRegion();

    const [newParticipant, setNewParticipant] = useState<NewParticipant>({
        firstName: "",
        lastName: "",
        participantEmail: "",
        caseworker: "",
        waiverId: "",
        region: 0,
        mobileNumber: "",
        countryCodeId: DefaultUSCountryCodeId, // Always US (+1)
        linkageDate: null,
        cpocDate: null,
        cpocEndDate: null,
        certificationDate: null,
        initial: true,
        participantSsnLast4: "", // Change to string and default to empty string
    });

    const [employees, setEmployees] = useState<UserWaiverDTO[] | null>([]);
    const [waivers, setWaivers] = useState<Waiver[] | null>([]);

    const [employeeOptions, setEmployeeOptions] = useState<OptionType[]>([]);
    const [waiverOptions, setWaiverOptions] = useState<OptionType[]>([]);
    const [regionOptions, setRegionOptions] = useState<OptionType[]>([]);

    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [errors, setErrors] = useState<{ [key: string]: string | undefined }>({});

    // Set default linkage date to today
    useEffect(() => {
        const today = new Date();
        setNewParticipant((prev) => ({
            ...prev,
            linkageDate: today,
        }));
    }, []);

    useEffect(() => {
        const fetchInfo = async () => {
            if (currentUser) {
                const authToken: string = await currentUser.getIdToken();
                const waiversFetched = await getWaivers(authToken);
                // const employeesFetched = await getAllUsersInOrganizationbyId(authToken);

                if (waiversFetched.success) {
                    setWaivers(waiversFetched.data);
                }
                // if (employeesFetched) {
                //     setEmployees(employeesFetched);
                // }
            }
        };

        // Get all region
        GetAllRegions();

        fetchInfo();
    }, [currentUser]);

    useEffect(()=>{
        GetEmployees();
    },[newParticipant.waiverId]);

    const GetEmployees = async () => {debugger
        const token = await currentUser?.getIdToken();

        const waiverCode = waivers?.find(w => w.id.toString() == newParticipant.waiverId)?.waiverName;
        if (!token || !waiverCode) return;

        try {
            const res = await GetParticipantByWaiverFamily(token, waiverCode);
            if(res.success){
                setEmployees(res.data);
            }
        } catch (error: any) {
            toast.error(error instanceof AxiosError ? error.response?.data.message : error.message || "Error to get Employees");
        }

    }

    useEffect(() => {
        if (waivers && waivers.length > 0) {
            const formattedWaivers = waivers.map((waiver) => ({
                value: waiver.id.toString(),
                label: waiver.waiverName,
            }));
            setWaiverOptions(formattedWaivers);
        }

        if (employees && employees.length > 0) {debugger
            const formattedEmployees = employees.map((employee) => ({
                value: employee.id.toString(),
                label: employee.displayName,
            }));
            setEmployeeOptions(formattedEmployees);
        }
    }, [employees, waivers]);

    console.log("New participant  : ", newParticipant);
    

    const handleWaiverChange = (selectedOption: SingleValue<OptionType>) => {
        setErrors(prev => ({ ...prev, waiverId: undefined })); // Clear error for waiverId
        const waiverId = selectedOption ? selectedOption.value : "";
        setNewParticipant({ ...newParticipant, waiverId, caseworker: "" });
    };

    const handleRegionChange = (selectedOption: SingleValue<OptionType>) => {
        setErrors(prev => ({ ...prev, region: undefined })); // Clear error for region
        const region = selectedOption ? parseInt(selectedOption.value) : 0;
        setNewParticipant({ ...newParticipant, region });
    };

    const handleDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setErrors(prev => ({ ...prev, [name]: undefined })); // Clear error for this field
        setNewParticipant({ ...newParticipant, [name]: value });
    };

    const handleAssigneeChange = (selectedOption: SingleValue<OptionType>) => {
        setErrors(prev => ({ ...prev, caseworker: undefined })); // Clear error for caseworker
        const caseworker = selectedOption ? selectedOption.value : "";
        setNewParticipant({ ...newParticipant, caseworker });
    };

    // --- Validation helpers ---
    const isValidEmail = (email: string) =>
        /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

    const isValidUSPhone = (phone: string) =>
        /^(\d{10})$/.test(phone.replace(/\D/g, ""));

    // --- Input handlers with trimming ---
    const handleChange = (
        e: React.ChangeEvent<
            HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
        >
    ) => {
        const { name, value } = e.target;
        setErrors(prev => ({ ...prev, [name]: undefined }));

        let trimmedValue = value.trim();

        if (name === "participantSsnLast4") {
            // Only allow up to 4 digits, no letters or other characters
            const digitsOnly = trimmedValue.replace(/\D/g, "").slice(0, 4);
            setNewParticipant({ ...newParticipant, [name]: digitsOnly });
        } else if (name === "mobileNumber") {
            // Allow only digits, max 10
            const digitsOnly = trimmedValue.replace(/\D/g, "").slice(0, 10);
            setNewParticipant({ ...newParticipant, [name]: digitsOnly });
        } else if (name === "participantEmail" || name === "firstName" || name === "lastName") {
            setNewParticipant({ ...newParticipant, [name]: trimmedValue });
        } else {
            setNewParticipant({ ...newParticipant, [name]: value });
        }
    };

    // --- Validation helpers ---
    const validateFields = () => {
        const newErrors: { [key: string]: string } = {};

        if (newParticipant.firstName.trim() === "") {
            newErrors.firstName = "First Name is required.";
        }
        if (newParticipant.lastName.trim() === "") {
            newErrors.lastName = "Last Name is required.";
        }
        // Email is optional, but if present, must be valid
        if (newParticipant.participantEmail) {
            if (!isValidEmail(newParticipant.participantEmail)) {
                newErrors.participantEmail = "Invalid email address.";
            }
        }
        // Phone is optional, but if present, must be valid
        if (newParticipant.mobileNumber) {
            if (!isValidUSPhone(newParticipant.mobileNumber)) {
                newErrors.mobileNumber = "Phone number must be 10 digits (US).";
            }
        }
        if (newParticipant.waiverId === "") {
            newErrors.waiverId = "Participant Waiver is required.";
        }
        if (newParticipant.caseworker === "") {
            newErrors.caseworker = "Caseworker is required.";
        }
        if (newParticipant.region === 0) {
            newErrors.region = "Region is required.";
        }
        if (!newParticipant.linkageDate) {
            newErrors.linkageDate = "Linkage Date is required.";
        }

        // SSN validation: must be exactly 4 digits if provided
        if (newParticipant.participantSsnLast4 && newParticipant.participantSsnLast4 !== "") {
            if (!/^\d{4}$/.test(newParticipant.participantSsnLast4)) {
                newErrors.participantSsnLast4 = "SSN must be exactly 4 digits.";
            }
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const submit = async () => {
        setIsLoading(true);

        // Trim all text fields before submit
        const trimmedParticipant = {
            ...newParticipant,
            firstName: newParticipant.firstName.trim(),
            lastName: newParticipant.lastName.trim(),
            participantEmail: newParticipant.participantEmail ? newParticipant.participantEmail.trim() : null,
            mobileNumber: newParticipant.mobileNumber ? newParticipant.mobileNumber.trim() : null,
            countryCodeId: DefaultUSCountryCodeId // Always US (+1)
        };

        if (validateFields() && currentUser) {
            const authToken = await currentUser.getIdToken();
            const result = await postParticipant(trimmedParticipant, authToken);

            if (result.success) {
                toast.success(result.message);
                navigate("/edit/participants");
            } else {
                toast.error(result.message);
                console.error("Failed to create participant:", result.message);
            }
        } else {
            if (!currentUser) {
                toast.error("You must be logged in to create a participant.");
            }
        }
        setIsLoading(false);
    };

    const isFormValid = () => {
        const hasFirstName = newParticipant.firstName.trim() !== "";
        const hasLastName = newParticipant.lastName.trim() !== "";
        const hasWaiver = newParticipant.waiverId !== "";
        const hasCaseworker = newParticipant.caseworker !== "";
        const hasRegion = newParticipant.region !== 0;
        const hasLinkageDate = !!newParticipant.linkageDate;
        const isMobileValid = !newParticipant.mobileNumber || /^\d+$/.test(newParticipant.mobileNumber);

        return (
            hasFirstName &&
            hasLastName &&
            hasWaiver &&
            hasCaseworker &&
            hasRegion &&
            hasLinkageDate &&
            isMobileValid
        );
    };

    const GetAllRegions = async () => {
        const token = await currentUser?.getIdToken();
        if (!token) return;
        getAllRegions(token).then((res) => {
            if (res.success) {
                const formattedRegions = res.data.map((region) => ({
                    value: region.regionId.toString(),
                    label: region.regionName,
                }));
                setRegionOptions(formattedRegions);
            } else {
                toast.error(res.message);
            }
        }).catch((err) => {
            toast.error(err.message);
        })
    }

    const navigateToEditParticipant = () => {
        const isOwner = currentRoles?.some(r => r.name == ROLES.OWNER);
        if (isOwner) {
            navigate("/dashboard/owner/edit/participants");
        } else {
            navigate("/edit/participants")
        }
    }

    return (
        <>
            <div className="new_activity_container">
                <div className="common_card">
                    <div className="top border_tittle top_bar_flx justify-content-start align-items-start">
                        <button onClick={navigateToEditParticipant}><img style={{ width: '1.5rem' }} src={backarrowbtn} alt="backarrowbtn" /></button>
                        <div className="top_bar_tittle">
                            <h2>New Participant</h2>
                            <p>🎉 Congratulations! Every new participant is a new person we can help
                                together, this is definitely a cause for celebration!</p>
                        </div>
                    </div>
                    <div className="max-w-screen-sm mx-auto">
                        {/* Error banner removed */}
                    </div>
                    <div className="row mb-3">
                        <div className="col-md-6 mb-2">
                            <Form.Group>
                                <Form.Label className="fw-semibold">Participant First Name <span className="text-danger">*</span></Form.Label>
                                <Form.Control
                                    name="firstName"
                                    onChange={handleChange}
                                    placeholder="First Name"
                                    value={newParticipant.firstName}
                                />
                                {errors.firstName && <div className="text-danger">{errors.firstName}</div>}
                            </Form.Group>
                        </div>
                        <div className="col-md-6">
                            <Form.Group>
                                <Form.Label className="fw-semibold">Participant Last Name <span className="text-danger">*</span></Form.Label>
                                <Form.Control
                                    name="lastName"
                                    onChange={handleChange}
                                    placeholder="Last Name"
                                    value={newParticipant.lastName}
                                />
                                {errors.lastName && <div className="text-danger">{errors.lastName}</div>}
                            </Form.Group>
                        </div>
                        <div className="col-md-6">
                            <Form.Group>
                                <Form.Label className="fw-semibold">Participant Email (optional)</Form.Label>
                                <Form.Control
                                    name="participantEmail"
                                    onChange={handleChange}
                                    placeholder="Email"
                                    value={newParticipant.participantEmail || ""}
                                />
                                {errors.participantEmail && <div className="text-danger">{errors.participantEmail}</div>}
                            </Form.Group>
                        </div>
                        <div className="col-md-6">
                            <Form.Group>
                                <Form.Label className="fw-semibold">Mobile Telephone Number (optional)</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="mobileNumber"
                                    onChange={handleChange}
                                    placeholder="Mobile Telephone Number"
                                    value={newParticipant.mobileNumber || ""}
                                />
                                {errors.mobileNumber && <div className="text-danger">{errors.mobileNumber}</div>}
                            </Form.Group>
                        </div>
                        <div className="col-md-6">
                            <Form.Group>
                                <Form.Label className="fw-semibold">Participant Waiver <span className="text-danger">*</span></Form.Label>
                                <Select
                                    options={waiverOptions}
                                    value={waiverOptions.find(
                                        (option) => option.value === newParticipant.waiverId
                                    )}
                                    onChange={handleWaiverChange}
                                    className="react-select-container"
                                    classNamePrefix="react-select"
                                />
                                {errors.waiverId && <div className="text-danger">{errors.waiverId}</div>}
                            </Form.Group>
                        </div>
                        <div className="col-md-6">
                            <Form.Group>
                                <Form.Label className="fw-semibold">Caseworker <span className="text-danger">*</span></Form.Label>
                                <Select
                                    options={employeeOptions}
                                    value={employeeOptions.find(
                                        (option) => option.value === newParticipant.caseworker
                                    ) || null}
                                    onChange={handleAssigneeChange}
                                    className="react-select-container"
                                    classNamePrefix="react-select"
                                />
                                {errors.caseworker && <div className="text-danger">{errors.caseworker}</div>}
                            </Form.Group>
                        </div>
                        <div className="col-md-6">
                            <Form.Group>
                                <Form.Label className="fw-semibold">Region <span className="text-danger">*</span></Form.Label>
                                <Select
                                    options={regionOptions}
                                    value={regionOptions.find(
                                        (option) => option.value === newParticipant.region.toString()
                                    )}
                                    onChange={handleRegionChange}
                                    className="react-select-container"
                                    classNamePrefix="react-select"
                                />
                                {errors.region && <div className="text-danger">{errors.region}</div>}
                            </Form.Group>
                        </div>
                        <div className="col-md-6">
                            <Form.Group>
                                <Form.Label className="fw-semibold">Linkage Date <span className="text-danger">*</span></Form.Label>
                                <Form.Control
                                    type="date"
                                    name="linkageDate"
                                    max="9999-12-31"
                                    value={newParticipant.linkageDate instanceof Date ? newParticipant.linkageDate.toISOString().split('T')[0] : newParticipant.linkageDate || ""}
                                    onChange={handleDateChange}
                                />
                                {errors.linkageDate && <div className="text-danger">{errors.linkageDate}</div>}
                            </Form.Group>
                        </div>
                        <div className="col-md-6">
                            <Form.Group>
                                <Form.Label className="fw-semibold">Certification Date <span>(optional)</span></Form.Label>
                                <Form.Control
                                    type="date"
                                    name="certificationDate"
                                    max="9999-12-31"
                                    onChange={handleDateChange}
                                />
                            </Form.Group>
                        </div>
                        <div className="col-md-6">
                            <Form.Group>
                                <Form.Label className="fw-semibold">CPOC Start Date <span>(optional)</span></Form.Label>
                                <Form.Control
                                    type="date"
                                    name="cpocDate"
                                    max="9999-12-31"
                                    onChange={handleDateChange}
                                />
                            </Form.Group>
                        </div>
                        <div className="col-md-6">
                            <Form.Group>
                                <Form.Label className="fw-semibold">CPOC End Date <span>(optional)</span></Form.Label>
                                <Form.Control
                                    type="date"
                                    name="cpocEndDate"
                                    max="9999-12-31"
                                    onChange={handleDateChange}
                                />
                            </Form.Group>
                        </div>
                        <div className="col-md-6">
                            <Form.Group>
                                <Form.Label className="fw-semibold">Participant SSN Last 4 Digit <span>(optional)</span></Form.Label>
                                <Form.Control
                                    type="text"
                                    maxLength={4}
                                    name="participantSsnLast4"
                                    value={newParticipant.participantSsnLast4 || ""}
                                    onChange={handleChange}
                                    placeholder="Last 4 digits of SSN"
                                    pattern="\d{4}"
                                    inputMode="numeric"
                                />
                                {errors.participantSsnLast4 && <div className="text-danger">{errors.participantSsnLast4}</div>}
                            </Form.Group>
                        </div>
                        <Form.Group controlId="">
                            <Form.Check
                                type="checkbox"
                                id="initial-linkage"
                                name="agreement"
                                label="Initial Linkage"
                                className='check_with_label_two'
                            />
                        </Form.Group>
                    </div>
                    <div className="form_btn_flx mby_t_24">
                        {isLoading ? (
                            <Button variant="primary" disabled className="dark-button">
                                <Spinner size="sm" /> Creating...
                            </Button>
                        ) : (
                            <Button variant="primary" onClick={submit} className="dark-button" disabled={!isFormValid()}>
                                Submit
                            </Button>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

export default CreateParticipantPage;
